import { render, staticRenderFns } from "./NotificacionesPoliciaMenu.vue?vue&type=template&id=79834150&scoped=true"
import script from "./NotificacionesPoliciaMenu.vue?vue&type=script&lang=js"
export * from "./NotificacionesPoliciaMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificacionesPoliciaMenu.vue?vue&type=style&index=0&id=79834150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79834150",
  null
  
)

export default component.exports